import React from 'react';
import { createPortal } from 'react-dom';
import ConfirmModal from '../ui/ConfirmModal';
import { useClearPhaseStartMutation } from '../../hooks/useClearPhaseStartMutation';

/**
 * The confirm step for "Clear start", shared by the job edit form and the
 * dispatch card's menu. Portalled to <body>, and every pointer event stopped at
 * the wrapper: React bubbles synthetic events through a portal to its React
 * ancestors, and on the board those include the card's drag listeners and its
 * navigate-on-click (same treatment as CrewPhaseDialog).
 */
export default function ClearPhaseStartConfirm({
  jobId,
  jobNumber,
  phase,
  startedLabel,
  onClose,
}: {
  jobId: string;
  jobNumber?: string;
  phase: 'wash' | 'run';
  /** The start as the screen shows it, e.g. "Oct 10 09:42". */
  startedLabel: string;
  onClose: () => void;
}) {
  const clear = useClearPhaseStartMutation();
  const stop = (e: React.SyntheticEvent) => e.stopPropagation();
  const label = phase === 'wash' ? 'Wash' : 'Run';
  return createPortal(
    <div onPointerDown={stop} onTouchStart={stop} onClick={stop} onMouseDown={stop} onKeyDown={stop}>
      <ConfirmModal
        isOpen
        title={`Clear the ${phase} start?`}
        body={`${label} started ${startedLabel} will be removed, so the board shows the ${phase} on its scheduled day. The job's status does not change.`}
        confirmLabel="Clear start"
        loading={clear.isPending}
        onCancel={onClose}
        onConfirm={() => clear.mutate({ jobId, phase, jobNumber }, { onSettled: onClose })}
      />
    </div>,
    document.body,
  );
}
